import styled from 'styled-components';

const NetworkOfRepresentativesTemplateStyle = styled.section`
	--heroPointsDistance: 140px;

	margin-top: var(--pageDistance);

	&.has-points {
		.global-hero-section {
			.section {
				margin-bottom: var(--heroPointsDistance);
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--heroPointsDistance: var(--sp13x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--heroPointsDistance: var(--sp12x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--heroPointsDistance: var(--sp10x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--heroPointsDistance: var(--sp9x);
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--heroPointsDistance: var(--sp8x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--heroPointsDistance: var(--sp4x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--heroPointsDistance: var(--sp3x);
	}
`;

export default NetworkOfRepresentativesTemplateStyle;
